/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminElementLogin
 */
export interface InputAdminElementLogin {
    /**
     * Homeserver — на який homeserver логінити бота (перемикання delta/matrix.org). Порожній —
     * дефолт (перший homeserver-preset). Зміна проти збереженої сесії авто-чистить crypto-store.
     * @type {string}
     * @memberof InputAdminElementLogin
     */
    homeserver?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminElementLogin
     */
    loginToken: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminElementLogin
     */
    recoveryKey: string;
}

/**
 * Check if a given object implements the InputAdminElementLogin interface.
 */
export function instanceOfInputAdminElementLogin(value: object): boolean {
    if (!('loginToken' in value)) return false;
    if (!('recoveryKey' in value)) return false;
    return true;
}

export function InputAdminElementLoginFromJSON(json: any): InputAdminElementLogin {
    return InputAdminElementLoginFromJSONTyped(json, false);
}

export function InputAdminElementLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminElementLogin {
    if (json == null) {
        return json;
    }
    return {
        
        'homeserver': json['homeserver'] == null ? undefined : json['homeserver'],
        'loginToken': json['loginToken'],
        'recoveryKey': json['recoveryKey'],
    };
}

export function InputAdminElementLoginToJSON(value?: InputAdminElementLogin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'homeserver': value['homeserver'],
        'loginToken': value['loginToken'],
        'recoveryKey': value['recoveryKey'],
    };
}

